import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@services/auth.guard';
import { ModuleAvailabilityGuard } from '@services/module_availability.guard';
import { QuicklinkStrategy } from 'ngx-quicklink';

export const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then((m) => m.HomePageModule),
    canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/auth/login/login.module').then((m) => m.LoginPageModule)
  },
  {
    path: 'request-history',
    loadChildren: () =>
      import('./pages/request-history/request-history.module').then((m) => m.RequestHistoryPageModule),
    canActivate: [AuthGuard, ModuleAvailabilityGuard],
    data: { preload: true },
    pathMatch: 'full'
  },
  {
    path: 'request-history/:section',
    loadChildren: () =>
      import('./pages/request-history/request-history.module').then((m) => m.RequestHistoryPageModule),
    canActivate: [AuthGuard, ModuleAvailabilityGuard],
    data: { preload: true }
  },
  {
    path: 'request-history/get_sample/:id',
    loadChildren: () =>
      import('./pages/request-history/request-history.module').then((m) => m.RequestHistoryPageModule),
    canActivate: [AuthGuard, ModuleAvailabilityGuard],
    data: { preload: true }
  },
  {
    path: 'request-history/rpd',
    loadChildren: () =>
      import('./pages/request-history/request-history.module').then((m) => m.RequestHistoryPageModule),
    canActivate: [AuthGuard, ModuleAvailabilityGuard],
    data: { preload: true }
  },
  {
    path: 'new-gather',
    loadChildren: () => import('./pages/request/gather/gather.module').then((m) => m.GatherPageModule),
    canActivate: [AuthGuard, ModuleAvailabilityGuard],
    data: { preload: true }
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/profile.module').then((m) => m.ProfilePageModule),
    canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'sample',
    loadChildren: () => import('./pages/request/sample/sample.module').then((m) => m.SamplePageModule),
    canActivate: [AuthGuard, ModuleAvailabilityGuard],
    data: { preload: true }
  },
  {
    path: 'kit-request',
    loadChildren: () => import('./pages/request/kit-request/kit-request.module').then((m) => m.KitRequestPageModule),
    canActivate: [AuthGuard, ModuleAvailabilityGuard],
    data: { preload: true }
  },
  {
    path: 'configuration',
    loadChildren: () => import('./pages/configuration/configuration.module').then((m) => m.ConfigurationPageModule),
    canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'releases',
    loadChildren: () => import('./modals/features/releases/releases.module').then((m) => m.ReleasesPageModule),
    canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'terminos',
    loadChildren: () => import('./pages/docs/terms/terms.module').then( m => m.TermsPageModule)
  },
  {
    path: 'confirm-registration/:token',
    loadChildren: () => import('./pages/auth/confirm-registration/confirm-registration.module').then(m => m.ConfirmRegistrationPageModule)
  }
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: QuicklinkStrategy,
      useHash: true
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
